<template>
    <div class="hero">
      <img :src="image" />
      <share-button />
      <div class="hero__overlay" v-if="title || subTitle">
        <span class="hero__line hero__line--underlined">{{ title }}</span>
        <span class="hero__seperator"></span>
        <span class="hero__line">{{ subTitle }}</span>
      </div>
    </div>
</template>

<script>

import ShareButton from './ShareButton'

export default {
  props: {
    image: String,
    title: String,
    subTitle: String
  },

  components: {
    ShareButton
  }
}

</script>
